import LocalizedStrings from 'localized-strings';

const commonLocales = {
  en: {
    backButtonClose: 'Close',
    ctaContinue: 'Continue',
    refusedLabel: 'Refused',
    title: 'Company registration papers',
  },
  fr: {
    backButtonClose: 'Fermer',
    ctaContinue: 'Continuer',
    refusedLabel: 'Refusé',
    title: 'Immatriculation de votre entreprise',
  },
};

const nonEiLocales = {
  en: {
    aboutDocument:
      'In order to open your Shine account, we need your company registration document (Kbis).',
    addDocumentAction: 'Add your Kbis',
    documentName: 'Kbis',
    faqQuestions: 'How and why should you upload your Kbis?',
  },
  fr: {
    aboutDocument:
      'Pour ouvrir votre compte Shine, nous avons besoin de votre Kbis pour vérifier l’immatriculation de votre entreprise.',
    addDocumentAction: 'Ajoutez votre Kbis',
    documentName: 'Kbis',
    faqQuestions: 'Pourquoi et comment transmettre votre Kbis\u00A0?',
  },
};

const eiLocales = {
  en: {
    aboutDocument:
      'In order to open your Shine account, we need your company registration document (avis Sirene).',
    addDocumentAction: 'Add your avis Sirene',
    documentName: 'Avis Sirene',
    faqQuestions: 'How and why should you upload your avis Sirene?',
  },
  fr: {
    aboutDocument:
      'Pour ouvrir votre compte Shine, nous avons besoin de votre avis Sirene pour vérifier l’immatriculation de votre entreprise.',
    addDocumentAction: 'Ajoutez votre avis Sirene',
    documentName: 'Avis Sirene',
    faqQuestions: 'Pourquoi et comment transmettre votre avis Sirene\u00A0?',
  },
};

const getLocales = (isEi: boolean) =>
  new LocalizedStrings({
    en: {
      ...commonLocales.en,
      ...(isEi ? eiLocales.en : nonEiLocales.en),
    },
    fr: {
      ...commonLocales.fr,
      ...(isEi ? eiLocales.fr : nonEiLocales.fr),
    },
  });

export default getLocales;
